namespace TabAurous.OMS {
    export interface CommonAttributesRow {
        AttributeId?: number;
        Attribute?: string;
        ProductTypeId?: number;
        ProductTypeCode?: string;
        ProductTypeName?: string;
        ItemTypeId?: number;
        ItemType?: string;
        CategoryId?: number;
        CategoryCode?: string;
        CategoryName?: string;
        SubCategoryId?: number;
        SubCategoryCode?: string;
        SubCategoryName?: string;
        KaratId?: number;
        KaratCode?: string;
        KaratName?: string;
        MetalColorId?: number;
        MetalColorCode?: string;
        MetalColorName?: string;
        ProductSizeId?: number;
        ProductSizeCode?: string;
        ProductSizeName?: string;
        StoneSizeId?: number;
        StoneSizeCode?: string;
        StoneSizeName?: string;
        BrandId?: number;
        BrandCode?: string;
        BrandName?: string;
        CollectionId?: number;
        CollectionCode?: string;
        CollectionName?: string;
        SuperTypeId?: number;
        SuperTypeCode?: string;
        SuperTypeName?: string;
        ShapeId?: number;
        ShapeCode?: string;
        ShapeName?: string;
        SieveId?: number;
        SieveCode?: string;
        SieveName?: string;
        GroupSieveId?: number;
        GroupSieveCode?: string;
        GroupSieveName?: string;
        QualityId?: number;
        QualityCode?: string;
        QualityName?: string;
        StoneColorId?: number;
        StoneColorCode?: string;
        StoneColoreName?: string;
        StampId?: number;
        StampCode?: string;
        StampName?: string;
        MetalId?: number;
        MetalCode?: string;
        MetalName?: string;
        SettingName?: string;
        StoneCutId?: number;
        StoneCutCode?: string;
        StoneCutName?: string;
        StonePolishId?: number;
        StonePolishCode?: string;
        StonePolishName?: string;
        StoneSymmetryId?: number;
        StoneSymmetryCode?: string;
        StoneSymmetryName?: string;
        StoneFluorescenceId?: number;
        StoneFluorescenceCode?: string;
        StoneFluorescenceName?: string;
        StoneCuletId?: number;
        StoneCuletCode?: string;
        StoneCuletName?: string;
        StoneGirdleId?: number;
        StoneGirdleCode?: string;
        StoneGirdleName?: string;
        StoneTable?: string;
        StoneDepth?: string;
        Num1?: number;
        Num2?: number;
        Num3?: number;
        String1?: string;
        String2?: string;
        String3?: string;
    }

    export namespace CommonAttributesRow {
        export const idProperty = 'AttributeId';
        export const nameProperty = 'Attribute';
        export const localTextPrefix = 'ItemFields';
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            AttributeId = "AttributeId",
            Attribute = "Attribute",
            ProductTypeId = "ProductTypeId",
            ProductTypeCode = "ProductTypeCode",
            ProductTypeName = "ProductTypeName",
            ItemTypeId = "ItemTypeId",
            ItemType = "ItemType",
            CategoryId = "CategoryId",
            CategoryCode = "CategoryCode",
            CategoryName = "CategoryName",
            SubCategoryId = "SubCategoryId",
            SubCategoryCode = "SubCategoryCode",
            SubCategoryName = "SubCategoryName",
            KaratId = "KaratId",
            KaratCode = "KaratCode",
            KaratName = "KaratName",
            MetalColorId = "MetalColorId",
            MetalColorCode = "MetalColorCode",
            MetalColorName = "MetalColorName",
            ProductSizeId = "ProductSizeId",
            ProductSizeCode = "ProductSizeCode",
            ProductSizeName = "ProductSizeName",
            StoneSizeId = "StoneSizeId",
            StoneSizeCode = "StoneSizeCode",
            StoneSizeName = "StoneSizeName",
            BrandId = "BrandId",
            BrandCode = "BrandCode",
            BrandName = "BrandName",
            CollectionId = "CollectionId",
            CollectionCode = "CollectionCode",
            CollectionName = "CollectionName",
            SuperTypeId = "SuperTypeId",
            SuperTypeCode = "SuperTypeCode",
            SuperTypeName = "SuperTypeName",
            ShapeId = "ShapeId",
            ShapeCode = "ShapeCode",
            ShapeName = "ShapeName",
            SieveId = "SieveId",
            SieveCode = "SieveCode",
            SieveName = "SieveName",
            GroupSieveId = "GroupSieveId",
            GroupSieveCode = "GroupSieveCode",
            GroupSieveName = "GroupSieveName",
            QualityId = "QualityId",
            QualityCode = "QualityCode",
            QualityName = "QualityName",
            StoneColorId = "StoneColorId",
            StoneColorCode = "StoneColorCode",
            StoneColoreName = "StoneColoreName",
            StampId = "StampId",
            StampCode = "StampCode",
            StampName = "StampName",
            MetalId = "MetalId",
            MetalCode = "MetalCode",
            MetalName = "MetalName",
            SettingName = "SettingName",
            StoneCutId = "StoneCutId",
            StoneCutCode = "StoneCutCode",
            StoneCutName = "StoneCutName",
            StonePolishId = "StonePolishId",
            StonePolishCode = "StonePolishCode",
            StonePolishName = "StonePolishName",
            StoneSymmetryId = "StoneSymmetryId",
            StoneSymmetryCode = "StoneSymmetryCode",
            StoneSymmetryName = "StoneSymmetryName",
            StoneFluorescenceId = "StoneFluorescenceId",
            StoneFluorescenceCode = "StoneFluorescenceCode",
            StoneFluorescenceName = "StoneFluorescenceName",
            StoneCuletId = "StoneCuletId",
            StoneCuletCode = "StoneCuletCode",
            StoneCuletName = "StoneCuletName",
            StoneGirdleId = "StoneGirdleId",
            StoneGirdleCode = "StoneGirdleCode",
            StoneGirdleName = "StoneGirdleName",
            StoneTable = "StoneTable",
            StoneDepth = "StoneDepth",
            Num1 = "Num1",
            Num2 = "Num2",
            Num3 = "Num3",
            String1 = "String1",
            String2 = "String2",
            String3 = "String3"
        }
    }
}
